import { plainToInstance, Type } from 'class-transformer'
import moment from 'moment'
import { Entity } from '@core/entities/entity'
import { User } from '@core/entities/user'
import { IAuditCheckInExtension } from './IAuditCheckInExtension'

export class AuditCheckInExtension extends Entity<IAuditCheckInExtension> {
  checkInSessionId: number
  @Type(() => User)
  user?: User
  previousExpectedCheckOutOn: string
  expectedCheckOutOn: string

  public static new(payload: unknown): AuditCheckInExtension {
    return plainToInstance(AuditCheckInExtension, payload)
  }

  public getFormattedPreviousExpectedCheckOutOn(): string {
    return moment(this.previousExpectedCheckOutOn).format('DD MMM YYYY HH:mm')
  }

  public getFormattedExpectedCheckOutOn(): string {
    return moment(this.expectedCheckOutOn).format('DD MMM YYYY HH:mm')
  }
}
